// extracted by mini-css-extract-plugin
export var background = "_70-0";
export var container = "_70-1";
export var contentItem = "_70-7";
export var extendedWarranty = "_70-5";
export var link = "_70-d";
export var modal = "_70-b";
export var modalCloseButton = "_70-9";
export var modalContent = "_70-3";
export var modalContentMain = "_70-6";
export var modalImageLogo = "_70-8";
export var modalLogo = "_70-a";
export var modalSideImage = "_70-4";
export var preview = "_70-c";
export var redoModal = "_70-2";